import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select, Space, Table } from 'antd';
import dayjs from 'dayjs';

import React, { useContext, useEffect, useRef, useState } from 'react'
import systemConfig from '../../../../config/systematic';
import fetchApi from '../../../../utils/api/fetchApi';
import getList from '../../../universal/getList';
import antMessage from '../../../../utils/extend/AntdNotification'
import 'dayjs/locale/zh-cn';
import { showCustomNotification, useNotificationInstance } from '../../../../utils/extend/AntdNotificationEx';
import { SocketContext } from '../../../../App';
import moment from 'moment';
import entrepotPrint from '../../../../generalMethod/entrepotPrint';
import DownloadExcel from '../../../report/DownloadExcel';


export default function PurchaseSaleStockStatistics() {

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;
    const [form] = Form.useForm()
    const [queryCriteria, setQueryCriteria] = useState<any>("")
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const zeroStatus: Array<any> = [
        { id: 1, name: "所有库存" },
        { id: 2, name: "库存为0" },
        { id: 3, name: "库存非0" },
        { id: 4, name: "涉及库存变动" },


    ]
    const [user, setUser] = useState<any>("")
    const notificationApi = useNotificationInstance()
    const [accountantData, setAccountantData] = useState<Array<any>>([])
    const [classificationWarehouseData, setClassificationWarehouseData] = useState<any>();
    // 
    const [rows, setRows] = useState<any>([]);
    const [accountantDisabled, setAccountantDisabled] = useState<Boolean>(true)
    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;
    const contentRef = useRef<any>(null);
    const [productModel, setProductModel] = useState<any>([
        { id: "rangeNumSearch", name: "品号范围搜索" },
        { id: "similarNumSearch", name: "品号相似搜索" },
        { id: "equalNumSearch", name: "品号相等搜索" },
        { id: "similarNameSearch", name: "品名相似搜索" },
        { id: "equalNameSearch", name: "品名相等搜索" },
    ])
    const [selectProdutModel, setSelectProdutModel] = useState<any>("rangeNumSearch")
    const initialValues: any = {
        chooseTime: [dayjs(), dayjs()],
        isBuyerDetail: true,
        isCurrentAccountant: true,
        zeroStatus: 1,
        productModel: "rangeNumSearch"
    };
    const [warehouseCategoriesData, setWarehouseCategoriesData] = useState<any>([])
    const [columnsHead, setColumnsHead] = useState<Array<any>>()
    useEffect(() => {
        const fetchData = async () => {
            form.setFieldValue("chooseTime", [dayjs(), dayjs()])

            fetchApi.GET(wmService, {
                apiId: 'accountant',
                apiExtend: "showList",
                apiData: {
                    entrepotId: contextData?.currentEntrepotId,
                }
            }).then((res) => {
                setAccountantData(res.data)

            })
            let warehouseCategoriesData = await fetchApi.GET(wmService, {
                apiId: "warehouseCategories",
                apiExtend: 'showList'
            })


            if (warehouseCategoriesData.success) {

                setWarehouseCategoriesData(warehouseCategoriesData.data)
            }
            let classificationWarehouseData = await fetchApi.GET(wmService, {
                apiId: "classificationWarehouse",
                apiExtend: 'showList'
            })



            if (classificationWarehouseData.success) {

                setClassificationWarehouseData(classificationWarehouseData.data)
            }

            // 
        }
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])



    const onFinish = () => {
        setIsLoading(true)
        form.validateFields()
            .then(async (values: any) => {
                fetchApi.GET(wmService, {
                    apiId: "entrepotReport",
                    apiExtend: 'purchaseSaleStockStatistics',
                    apiData: {
                        ...values,
                        entrepotId: contextData?.currentEntrepotId,
                        accountantId: values.accountantId,
                        selfs: values.selfStart && values.selfEnd ? {
                            selfStart: values.selfStart,
                            selfEnd: values.selfEnd
                        } : null,
                        mountDataOptions: {
                            userMount: {
                                isEmployees: true,
                                isDept: true,
                                isUserAreas: true
                            }
                        },
                    }
                }).then((res: any) => {

                    /** 表头内容 */
                    let initColumnsHead: Array<any> = [
                        {
                            title: res.data.queryCriteria.entrepotName,
                            align: "center",

                            children: [
                                {
                                    title: "品号",
                                    dataIndex: "selfId",
                                    width: "5%",
                                    key: "selfId",
                                    header: "品号",
                                    sortBy: 1,
                                    init: true,
                                    align: "center",

                                },
                                 {
                                    title: "品类",
                                    dataIndex: "classificationWarehouseName",
                                    width: "7%",
                                    key: "classificationWarehouseName",
                                    header: "品类",
                                    sortBy: 2,
                                    init: true,
                                    align: "center",

                                },
                                {
                                    title: "品名",
                                    dataIndex: "productName",
                                    width: "15%",
                                    key: "productName",
                                    header: "品号",
                                    sortBy: 2,
                                    init: true,
                                    align: "center",

                                },
                                {
                                    title: "单位",
                                    dataIndex: "productUnitName",
                                    width: "6%",
                                    key: "productUnitName",
                                    header: "单位",
                                    sortBy: 3,
                                    init: true,
                                    align: "center",

                                },
                                {
                                    title: "期初",
                                    // dataIndex: "productUnitName",
                                    // width: 20,
                                    align: "center",
                                    // key: "productUnitName",
                                    header: "期初",
                                    sortBy: 20,
                                    init: true,
                                    children: [
                                        {
                                            title: '数量',
                                            dataIndex: "openingQuantity", // 匹配数据中的 dB410c40671111edaa76d1ceff87fc2b_pnumber
                                            key: "openingQuantity",
                                            width: "7.4%",
                                            align: "center",

                                        },
                                        {
                                            title: '金额',
                                            dataIndex: 'openingPrice',
                                            key: "openingPrice",
                                            width: "7.4%",
                                            align: "center",

                                        }
                                    ]
                                },
                                {
                                    title: "本期进货",
                                    // dataIndex: "productUnitName",
                                    // width: 20,
                                    align: "center",

                                    // key: "productUnitName",
                                    header: "本期进货",
                                    sortBy: 20,
                                    init: true,
                                    children: [
                                        {
                                            title: '数量',
                                            align: "center",

                                            dataIndex: "importQuantity", // 匹配数据中的 dB410c40671111edaa76d1ceff87fc2b_pnumber
                                            key: "importQuantity",
                                            width: "7.4%",
                                        },
                                        {
                                            title: '金额',
                                            align: "center",

                                            dataIndex: 'importPrice',
                                            key: "importPrice",
                                            width: "7.4%",
                                        }
                                    ]
                                },
                                {
                                    title: "本期销货",

                                    // dataIndex: "productUnitName",
                                    // width: 20,
                                    // key: "productUnitName",
                                    header: "本期销货",
                                    align: "center",

                                    sortBy: 20,
                                    init: true,
                                    children: [
                                        {
                                            title: '数量',
                                            align: "center",

                                            dataIndex: "exportQuantity", // 匹配数据中的 dB410c40671111edaa76d1ceff87fc2b_pnumber
                                            key: "exportQuantity",
                                            width: "7.4%",
                                        },
                                        {
                                            title: '金额',
                                            align: "center",

                                            dataIndex: 'exportPrice',
                                            key: "exportPrice",
                                            width: "7.4%",
                                        }
                                    ]
                                },
                                {
                                    title: "本期调整",
                                    align: "center",

                                    // dataIndex: "productUnitName",
                                    // width: 20,
                                    // key: "productUnitName",
                                    header: "本期调整",
                                    sortBy: 20,
                                    init: true,
                                    children: [
                                        {
                                            title: '数量',
                                            align: "center",

                                            dataIndex: "incomeStatementQuantity", // 匹配数据中的 dB410c40671111edaa76d1ceff87fc2b_pnumber
                                            key: "incomeStatementQuantity",
                                            width: "7.4%",
                                        },
                                        {
                                            title: '金额',
                                            align: "center",

                                            dataIndex: 'incomeStatementPrice',
                                            key: "incomeStatementPrice",
                                            width: "7.4%",
                                        }
                                    ]
                                },
                                {
                                    title: "本期结存",
                                    align: "center",

                                    // dataIndex: "productUnitName",
                                    // width: 20,
                                    // key: "productUnitName",
                                    header: "本期结存",
                                    sortBy: 20,
                                    init: true,
                                    children: [
                                        {
                                            title: '数量',
                                            align: "center",

                                            dataIndex: "balanceQuantity", // 匹配数据中的 dB410c40671111edaa76d1ceff87fc2b_pnumber
                                            key: "balanceQuantity",
                                            width: "7.4%",
                                        },
                                        {
                                            title: '金额',
                                            align: "center",

                                            dataIndex: 'balancePrice',
                                            key: "balancePrice",
                                            width: "7.4%",
                                        }
                                    ]
                                },

                            ]
                        },

                    ]
                    setIsLoading(false)
                    setColumnsHead(initColumnsHead)

                    setRows(res.data.rows)
                    setQueryCriteria(res.data.queryCriteria)
                    //   setUser(res.data.user)
                    showCustomNotification(notificationApi!, {
                        type: 'success',
                        message: "搜索成功",
                        description: "success"
                    });;

                }).catch((err: any) => {
                    console.log("err", err);
                    setIsLoading(false)
                    antMessage('error', '搜索失败', err.message + ' | status：' + err.errors.status);
                })
            })
            .catch((err) => {
                setIsLoading(false)
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: "请输入所需数据!"
                });;
            })
    }

    const currentAccountant = (e: any) => {
        let checked = e.target.checked;
        if (checked) {

            form.setFieldValue("accountantId", null)
            setAccountantDisabled(true)

        } else {
            setAccountantDisabled(false)
        }
    }
    // 修改后的 handlePrint 配置
    const handlePrint = () => {
        if (rows.length === 0) {
            antMessage('error', '打印失败', "无打印数据");
            return false
        }
        let table = document.getElementsByTagName("table")[0]
        table.border = "1";
        table.style.width = "100%";
        table.style.fontSize = "12px";

        table.cellPadding = "0";
        table.cellSpacing = "0";
        let data = document.getElementById("aa")?.innerHTML;
        entrepotPrint.printEnReportEx(JSON.stringify(data), "exDailyReport")
    }
    const changeProductModel = (e: any) => {
        setSelectProdutModel(e)

    }
    return (
        <>
            <Form
                form={form}
                onFinish={onFinish}
                initialValues={initialValues}
            >
                <Row>
                    <Col span={3}>
                        <Form.Item
                            label="会计期"
                            name="accountantId"
                        >
                            <Select
                                disabled={accountantDisabled ? true : false}
                                showSearch
                                placeholder="会计期"
                                optionFilterProp="children"
                                filterOption={(input: any, option: any) => {
                                    return true
                                }}
                            >
                                {getList.general(accountantData, 'accountantName')}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={1.5}>
                        <Form.Item
                            label="当前会计期"
                            name="isCurrentAccountant"
                            valuePropName="checked"


                        >
                            <Checkbox onChange={currentAccountant}></Checkbox>
                        </Form.Item>
                    </Col>
                    <Col span={3}>
                        <Form.Item
                            label="大类"
                            name="warehouseCategoriesIds"
                        >
                            <Select
                                mode="multiple"
                                showSearch
                                placeholder="大类"
                                optionFilterProp="children"
                                filterOption={(input: any, option: any) => {
                                    return true
                                }}
                            >
                                {getList.general(warehouseCategoriesData, 'warehouseCategoriesName')}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item label="品类" name="classificationWarehouses">
                            <Select
                                mode="multiple"
                                showSearch
                                placeholder="品类"
                                optionFilterProp="children"
                                onSearch={(e: any) => getList.search('classificationWarehouse', setClassificationWarehouseData, e)}
                                filterOption={(input: any, option: any) => true}
                            >
                                {getList.general(classificationWarehouseData, 'classificationWarehouseName')}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={3}>
                        <Form.Item
                            label="产品模式"
                            name="productModel"

                        >
                            <Select
                                // defaultValue={"rangeNumSearch"}
                                onChange={changeProductModel}
                                showSearch
                                placeholder="产品模式"
                                optionFilterProp="children"

                                filterOption={(input: any, option: any) => {
                                    return true
                                }}
                            >
                                {getList.general(productModel, 'name')}
                            </Select>
                        </Form.Item>
                    </Col>
                    {
                        selectProdutModel === "rangeNumSearch" ?
                            <>
                                <Col span={3}>
                                    <Form.Item
                                        label="品号"
                                        name="selfStart"
                                    >
                                        <Input
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={3}>
                                    <Form.Item
                                        colon={false}
                                        label="-"
                                        name="selfEnd"
                                    >
                                        <Input

                                        />
                                    </Form.Item>
                                </Col>
                            </>
                            : null
                    }

                    {
                        selectProdutModel === "similarNameSearch" || selectProdutModel === "equalNameSearch" ?
                            <>
                                <Col span={3}>
                                    <Form.Item
                                        label="品名"
                                        name="productName"
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>

                            </>
                            : null
                    }
                    {
                        selectProdutModel === "similarNumSearch" || selectProdutModel === "equalNumSearch" ?
                            <>
                                <Col span={3}>
                                    <Form.Item
                                        label="品号"
                                        name="selfId"
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>

                            </>
                            : null
                    }

                    <Col span={1.5}>
                        <Form.Item
                            label="库存状态"
                            name="zeroStatus"

                        >
                            <Select
                                showSearch
                                placeholder="库存状态"
                                optionFilterProp="children"
                                filterOption={(input: any, option: any) => {
                                    return true
                                }}
                            >
                                {getList.general(zeroStatus)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item >
                            <Space>
                                <Button loading={isLoading} htmlType="submit">
                                    统计
                                </Button >
                                <Button onClick={handlePrint}>打印</Button>
                                <Button onClick={() => DownloadExcel(rows, "purchaseSaleStockStatistics", { ...queryCriteria, columnsHead })}>下载EXCEL文件</Button>

                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>



            <div id='aa' ref={contentRef} >


                <Table
                    title={() => (<>
                        <div style={{ fontSize: 20, textAlign: "center", marginBottom: 10 }}>进销存统计表</div>
                        <div style={{ fontSize: 16, textAlign: "center", marginBottom: 10, display: "flex", justifyContent: "space-between", }}>
                            <div>日期:{queryCriteria.date}</div>
                            <div>打印日期：{moment().format("YYYY-MM-DD")}</div>
                        </div>
                        <div style={{ fontSize: 16, textAlign: "center", display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                            <div>品号:{queryCriteria.selfs}</div>
                        </div>
                    </>)}
                    style={{ fontSize: "13px" }}
                    pagination={false}
                    rowKey={(record: any) => record.id}
                    columns={columnsHead}
                    dataSource={rows}
                // summary={(pageData: any) => {
                //   let totalExport = 0;
                //   let totalExportCount = 0;

                //   let totalImport = 0;
                //   let totalImportCount = 0;

                //   let totalPurchase = 0;
                //   let totalPurchaseCount = 0;

                //   if (pageData.length > 0) {
                //     pageData.map((item: any) => {
                //       if (item.export) totalExport += item.export
                //       if (item.import) totalImport += item.import;
                //       if (item.purchase) totalPurchase += item.purchase;

                //       if (item.exportCount) totalExportCount += item.exportCount;
                //       if (item.importCount) totalImportCount += item.importCount;
                //       if (item.purchaseCount) totalPurchaseCount += item.purchaseCount;

                //     })
                //   }
                //   return (
                //     <Table.Summary  fixed>
                //       <Table.Summary.Row style={{"textAlign":"center"}}>
                //         <Table.Summary.Cell  index={0}>合计</Table.Summary.Cell>
                //         <Table.Summary.Cell  index={1}>{totalPurchase.toFixed(2)}</Table.Summary.Cell>
                //         <Table.Summary.Cell index={2}>{totalPurchaseCount}</Table.Summary.Cell>

                //         <Table.Summary.Cell index={3}>{totalImport.toFixed(2)}</Table.Summary.Cell>
                //         <Table.Summary.Cell index={4}>{totalImportCount}</Table.Summary.Cell>



                //         <Table.Summary.Cell index={5}>{totalExport.toFixed(2)}</Table.Summary.Cell>
                //         <Table.Summary.Cell index={6}>{totalExportCount}</Table.Summary.Cell>

                //       </Table.Summary.Row>
                //     </Table.Summary>
                //   )
                // }}
                >
                </Table>
            </div>
        </>
    )
}
export let handleData = (rows: any, objKey: string) => {
    let newArr: Array<any> = []

    if (typeof rows === "undefined") return newArr

    for (var i = 0; i < rows.length; i++) {
        newArr.push({
            [objKey]: rows[i]
        })
    }

    return newArr
}